<template>
  <div class="container-fluid session">
    <h6 class="title-font pt-3" style="text-align: center">{{ chartTitle }}</h6>
    <div :id="chartId" class="container-chart"></div>
    <div class="form-group row ml-3">
      <div class="col-auto">
        <div class="form-check">
          <input
            type="checkbox"
            class="form-check-input"
            value="grid"
            v-model="checkedGrid"
            checked
            @change="onChangeCheckedGrid"
          />
          <label class="form-check-label">{{ $t('battery.grid') }}</label>
        </div>
      </div>
      <div class="col-auto">
        <div class="form-check">
          <input
            type="checkbox"
            class="form-check-input"
            value="zoom"
            v-model="checkedZoom"
            @change="onChangeCheckedZoom"
          />
          <label class="form-check-label">{{ $t('battery.zoom') }}</label>
        </div>
      </div>
      <div class="col-auto">
        <div class="form-check">
          <input
            type="checkbox"
            class="form-check-input"
            value="crash"
            v-model="checkedCrash"
            @change="onChangeCheckedCrash"
          />
          <label class="form-check-label">{{ $t('battery.crashes') }}</label>
        </div>
      </div>
      <div class="col-auto">
        <div class="form-check">
          <input
            type="checkbox"
            class="form-check-input"
            value="overDay"
            v-model="checkedOverDay"
            @change="onChangeCheckedOverDay"
          />
          <label class="form-check-label">{{ $t('battery.over_day') }}</label>
        </div>
      </div>
      <div class="col-auto">
        <select
          class="custom-select custom-select-sm"
          v-model="selectedRange"
          @change="onRangeSelected"
        >
          <option value="all" selected>All</option>
          <option value="good">Good</option>
          <option value="medium">Medium</option>
          <option value="bad">Bad</option>
          <option value="verybad">Very bad</option>
        </select>
      </div>
    </div>
    <div class="form-group row ml-3">
      <div class="col-auto">
        <span id="batteryInformationLabel"></span>
      </div>
    </div>
  </div>
</template>

<script>
import * as d3 from 'd3'
import moment from 'moment-timezone'
import { utilsMixin } from '../../../utils/mixins'
import { BatteryLevelChartView } from '../../../utils/charts/BatteryLevelChartView'

export default {
  name: 'BatteryExploitationChart',
  mixins: [utilsMixin],
  data() {
    return {
      margin: { top: 10, right: 40, bottom: 20, left: 60 },
      chartWidth: 1080,
      chartHeight: 450,
      svg: Object(),
      chart: null,
      area: Object(),
      xAxis: Object(),
      yAxis: Object(),
      xAxisScale: null,
      yAxisScale: null,
      checkedGrid: ['grid'],
      checkedZoom: [],
      checkedCrash: [],
      checkedOverDay: [],
      localDataset: null,
      selectedRange: 'all',
    }
  },
  props: ['dataset', 'site', 'title', 'xTitle', 'yTitle'],
  mounted() {
    this.initChartView()
    moment.tz.setDefault('UTC')

    if (this.dataset) {
      this.localDataset = JSON.parse(JSON.stringify(this.dataset))
      this.chart.setDataset(this.localDataset)
      this.displayChart()
    }
  },
  watch: {
    dataset: {
      handler() {
        this.localDataset = JSON.parse(JSON.stringify(this.dataset))

        this.chartData = {
          type: this.dataset.type,
          items: this.dataset.levels,
        }
        this.$emit('update', this.chartData)
        this.chart.setDataset(this.localDataset)
        this.displayChart()
      },
      immediate: false,
    },
  },

  computed: {
    chartTitle: function() {
      if (this.chart) {
        return this.$t(`battery.infos_${this.dataset.type}`, [this.chart.dataset.levels.length])
      } else {
        return this.$t('battery.infos_levels', 0)
      }
    },
    chartId: function() {
      if (this.dataset.type) {
        return this.dataset.type + 'chart'
      } else {
        return 'battery_lifetimechart'
      }
    },
  },
  methods: {
    initChartView() {
      this.chart = new BatteryLevelChartView(
        this.chartId,
        this.localDataset,
        'battery',
        {
          width: this.chartWidth,
          height: this.chartHeight,
        },
        this.margin,
      )

      this.chart.initContainer(this.chartId)
      this.chart.setConfig({
        display_options: {
          zoomed: false,
          display_grid: true,
          over_day: false,
          range: 'all',
        },
      })

      this.chart.setOnLineClickHandler(sessionID => {
        window.open(`/session/${sessionID}`, '_blank')
      })
    },
    displayChart() {
      d3.select('#' + this.chartId + ' svg').remove()
      this.chart.initContainer(this.chartId)
      this.chart.draw()
      this.chart.displayGrid()
    },
    onChangeCheckedGrid() {
      this.chart.config.display_options.display_grid = this.checkedGrid.length > 0
      this.chart.displayGrid()
    },
    onChangeCheckedZoom() {
      this.chart.config.display_options.zoomed = this.checkedZoom.length > 0
      this.displayChart()
    },
    onChangeCheckedCrash() {
      this.localDataset.levels = this.dataset.levels.filter(level => {
        return this.checkedCrash.length > 0 ? level.is_crash : level
      })

      this.chart.setDataset(this.localDataset)
      this.displayChart()
    },
    onChangeCheckedOverDay() {
      // d3.select('#' + this.chartId + ' svg').remove()
      // this.initChartView()
      this.chart.config.display_options.over_day = this.checkedOverDay.length > 0
      this.displayChart()
    },
    onRangeSelected() {
      this.chart.config.display_options.range = this.selectedRange
      this.chart.setDataset(this.localDataset)
      this.displayChart()
    },
  },
}
</script>
